// Investor Dashboard specific API calls
// Assumed backend endpoints. TODO: Align with backend once implemented.
import api from './api';

export const investorDashboardAPI = {
    // Summary metrics for key cards
    getSummary: () => api.get('/api/investor/dashboard/summary'),
    // Current holdings (optionally limited)
    getHoldings: (params = {}) => api.get('/api/investor/dashboard/holdings', { params }),
    // Recent combined transactions (payouts + token transfers)
    getRecentTransactions: (params = {}) => api.get('/api/investor/dashboard/recent-transactions', { params }),
    // Upcoming payouts
    getUpcomingPayouts: (params = {}) => api.get('/api/investor/dashboard/upcoming-payouts', { params }),
    // Wallet status (reuse existing my-wallet endpoint with normalized shape)
    getWalletStatus: async () => {
        try {
            const resp = await api.get('/api/wallets/my-wallet');
            // Backend controller returns { wallet: { ...fields } } OR may wrap in data
            const rawWrapper = resp?.data?.data || resp?.data || {};
            const wallet = rawWrapper.wallet || rawWrapper; // support both shapes

            // Currently backend does NOT return on-chain balance in this endpoint.
            // We leave balance as 0 placeholder (future: separate blockchain balance fetch)
            return {
                connected: !!wallet.walletAddress,
                address: wallet.walletAddress || 'N/A',
                network: wallet.network || 'Unknown',
                status: wallet.status || 'unknown',
                walletType: wallet.walletType || 'N/A',
                securityLevel: wallet.securityLevel || 'N/A',
                riskProfile: wallet.riskProfile || 'N/A',
                lastActivity: wallet.lastActivity || wallet.updatedAt || wallet.createdAt || null,
                whitelisted: wallet.whitelisted ?? wallet.isWhitelisted ?? false,
                balance: wallet.balance ?? 0 // placeholder until balance endpoint exists
            };
        } catch (e) {
            return { connected: false, address: 'N/A', network: 'Unknown', status: 'error', walletType: 'N/A', securityLevel: 'N/A', riskProfile: 'N/A', lastActivity: null, whitelisted: false, balance: 0 };
        }
    }
};

export default investorDashboardAPI;
